import React,{useState} from "react";
import "./ribbon.scss"
import { Steps, Divider } from 'antd';
import 'antd/dist/antd.css';
//import ReactHlsPlayer from 'react-hls-player';


function Ribbon() {



    return(
       <>
           {/*<ReactHlsPlayer*/}
           {/*    src="https://live-cdn.tamasha.com/v1/live/98534eff2044a1e2674fa5185831a5d0/1626006878949/pid/s3mer/tamasha_karbala.stream/playlist_mid_live.m3u8"*/}
           {/*    autoPlay={false}*/}
           {/*    controls={true}*/}
           {/*    width="100%"*/}
           {/*    height="auto"*/}
           {/*/>*/}
       </>
    )
}

export default Ribbon;
